(() => {
  if (window.Bath4AllSkuLinks) return;
  window.Bath4AllSkuLinks = true;

  const contentSelector = '[data-b4a-sku-content], [data-b4a-sku-product] .newreadmoretext';
  const excludedSelector = 'a, script, style, textarea, select, button, code, pre, noscript';
  const pending = new Set();
  let scheduled = false;

  const escapeRegex = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const wordPart = (value) => /[A-Za-z0-9_#/-]/.test(value || '');

  function allowed(text, start, end, link, vendor) {
    if (wordPart(text[start - 1]) || wordPart(text[end])) return false;
    if (text[end] === '.' && /[A-Za-z0-9]/.test(text[end + 1] || '')) return false;
    const prefix = text.slice(Math.max(0, start - 100), start);
    const contextual = /(?:model|component|part|item|sku|catalog|jensen|rangaire|dryer)\s*(?:no\.?|number|#)?\s*[:#-]?\s*$/i.test(prefix);
    const numericContext = contextual || /accessor|include|sold separately|pair|compatible|recommended|suggested|replacement|requires|model|component|part|item|sku|drain|grid|faucet|basket|board|valve/i.test(prefix);
    const numeric = /^\d+$/.test(link.sku);
    const shortAlphanumeric = link.sku.length >= 3 && /[A-Za-z]/.test(link.sku) && /\d/.test(link.sku);
    if (((link.sku.length < 4 && !shortAlphanumeric) || numeric) && !(contextual || (numeric && link.sku.length >= 5 && numericContext))) return false;
    if (link.vendor.toLowerCase() !== vendor.toLowerCase() && !contextual && !text.toLowerCase().includes(link.vendor.toLowerCase())) return false;
    return true;
  }

  function hydrate(region) {
    const owner = region.dataset.b4aSkuContent || region.closest('[data-b4a-sku-product]')?.dataset.b4aSkuProduct;
    if (!owner) return;
    const mapElement = document.querySelector(`script[data-b4a-sku-map][data-product-id="${CSS.escape(owner)}"]`);
    if (!mapElement) return;
    let data;
    try { data = JSON.parse(mapElement.textContent); } catch { return; }
    if (!Array.isArray(data.links) || !data.links.length) return;
    const links = new Map();
    for (const link of data.links) {
      if (typeof link.sku !== 'string' || !link.sku || typeof link.url !== 'string' || typeof link.vendor !== 'string') continue;
      try {
        const url = new URL(link.url, window.location.origin);
        if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) continue;
        links.set(link.sku, { ...link, url: url.pathname + url.search });
      } catch {}
    }
    if (!links.size) return;
    const pattern = new RegExp([...links.keys()].sort((a, b) => b.length - a.length).map(escapeRegex).join('|'), 'g');
    const walker = document.createTreeWalker(region, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.textContent.trim() || node.parentElement?.closest(excludedSelector)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      const text = node.textContent;
      const matches = [...text.matchAll(pattern)].filter((match) => allowed(text, match.index, match.index + match[0].length, links.get(match[0]), data.vendor || ''));
      if (!matches.length) continue;
      const fragment = document.createDocumentFragment();
      let cursor = 0;
      for (const match of matches) {
        fragment.append(document.createTextNode(text.slice(cursor, match.index)));
        const link = links.get(match[0]);
        const anchor = document.createElement('a');
        anchor.href = link.url;
        anchor.target = '_blank';
        anchor.rel = 'noopener noreferrer';
        anchor.dataset.b4aSkuLink = '';
        anchor.textContent = match[0];
        if (typeof link.label === 'string') anchor.setAttribute('aria-label', link.label);
        fragment.append(anchor);
        cursor = match.index + match[0].length;
      }
      fragment.append(document.createTextNode(text.slice(cursor)));
      node.replaceWith(fragment);
    }
  }

  function queue(region) {
    pending.add(region);
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      for (const region of pending) if (region.isConnected) hydrate(region);
      pending.clear();
    });
  }

  function scan(node) {
    if (!(node instanceof Element)) return;
    if (node.matches(contentSelector)) queue(node);
    node.querySelectorAll(contentSelector).forEach(queue);
  }

  function initialize() {
    scan(document.documentElement);
    new MutationObserver((records) => {
      for (const record of records) {
        const parent = record.target instanceof Element ? record.target : record.target.parentElement;
        const region = parent?.closest(contentSelector);
        if (region) queue(region);
        record.addedNodes.forEach(scan);
      }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
